import {
  InfoPanel,
  Modal,
} from "@twinkltech/curriculum-architect-component-library";
import { Button, IconActionsExitToApp } from "@twinkltech/web-ui";
import { Trans, useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

import shapesOverlayUrl from "@/assets/images/shapes.svg?url";
import welcomeImage from "@/assets/images/welcome.jpg";

import { paths } from "@/paths";

import { MULTI_SCHOOL_ACCOUNT_MODAL_NS } from "./MultiSchoolAccountModal.i18n";
import styles from "./MultiSchoolAccountModal.module.css";

export const MultiSchoolAccountModal = () => {
  const { t } = useTranslation(MULTI_SCHOOL_ACCOUNT_MODAL_NS);

  return (
    <Modal open hasCloseButton={false} width="md" onClose={() => {}}>
      <Modal.ShapesBanner overlay={shapesOverlayUrl} src={welcomeImage} />
      <Modal.Header>
        <Modal.Title className={styles.heading}>{t("header")}</Modal.Title>
        <p>{t("description")}</p>
      </Modal.Header>
      <Modal.Body>
        <InfoPanel icon="Info" spacing="small">
          <p>
            <Trans
              components={{
                supportLink: (
                  <a
                    key={"customer-support-link"}
                    className={styles.supportLink}
                    href={paths.external.CUSTOMER_SUPPORT_URL}
                    rel="noreferrer noopener"
                    target="_blank"
                  />
                ),
              }}
              i18nKey="info_text"
              ns={MULTI_SCHOOL_ACCOUNT_MODAL_NS}
            />
          </p>
        </InfoPanel>
      </Modal.Body>
      <Modal.Footer>
        <IconActionsExitToApp />
        <Button
          as={Link}
          rel="noreferrer noopener"
          to={paths.external.TWINK_CA_LANDING}
          variant="primary"
        >
          {t("find_out_more_cta_text")}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};
